import api from './client'


export const organizationsApi = {
  getList: () => api.get('/organizations')
}
